export const SET_DEMANDE = 'SET_DEMANDE';
export const SET_DEMANDE_LOGISTIQUE = 'SET_DEMANDE_LOGISTIQUE';
export const SET_CRITERE = 'SET_CRITERE';
export const SET_CRITERE_LOGISTIQUE = 'SET_CRITERE_LOGISTIQUE';
export const SET_DATE_SELECT = 'SET_DATE_SELECT';
export const SET_LAST_PAYLOAD = 'SET_LAST_PAYLOAD';
export const SET_LAST_PAYLOAD_LOGISTIQUE = 'SET_LAST_PAYLOAD_LOGISTIQUE';
export const SET_TOTAL = 'SET_TOTAL';
